/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Delete_SuccessInputs */



/**
* | output |
* | --- |
* | "Latest commit deleted." |
*
* @param {Snapshot_History_Delete_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_delete_success = /** @type {((inputs?: Snapshot_History_Delete_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Delete_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Latest commit deleted.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Latest commit deleted.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Latest commit deleted.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Latest commit deleted.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Latest commit deleted.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Latest commit deleted.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Latest commit deleted.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Latest commit deleted.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Latest commit deleted.")
	return /** @type {LocalizedString} */ ("Latest commit deleted.")
});